import { executeMutation, GqlError } from 'src/models/model'
import Concern from 'src/models/model/concerns/Concern'

/**
 * Otpable provides OTP (One-Time Password) functionality to a Model.
 */
export default class Otpable extends Concern {
  static otpable = true

  static mutations = {
    createOtpCodeForEmail: {
      arguments: {
        email: {
          type: String,
          required: true
        },
        recaptchaToken: {
          type: String,
          required: false
        }
      },
      results: {
        success: Boolean,
        errors: [GqlError]
      }
    },
    createOtpCodeForPhone: {
      arguments: {
        phoneNumber: {
          type: String,
          required: true
        },
        recaptchaToken: {
          type: String,
          required: false
        }
      },
      results: {
        success: Boolean,
        errors: [GqlError]
      }
    }
  }

  static createOtpCodeForEmail (email, recaptchaToken = null) {
    return executeMutation(
      'createOtpCodeForEmail',
      { email, recaptchaToken },
      {
        success: true,
        errors: {
          structure: {
            code: true,
            description: true
          }
        }
      }
    )
  }

  static createOtpCodeForPhone (phoneNumber, recaptchaToken = null) {
    return executeMutation(
      'createOtpCodeForPhone',
      { phoneNumber, recaptchaToken },
      {
        success: true,
        errors: {
          structure: {
            code: true,
            description: true
          }
        }
      }
    )
  }

  static verifyOtpCodeForEmail (otpCode, email, recaptchaToken = null) {
    return executeMutation(
      'verifyOtpCodeForEmail',
      { otpCode, email, recaptchaToken },
      {
        success: true,
        user: {
          structure: {
            id: true
          }
        },
        errors: {
          structure: {
            code: true,
            description: true
          }
        }
      }
    )
  }

  static verifyOtpCodeForPhone (otpCode, phoneNumber, recaptchaToken = null) {
    return executeMutation(
      'verifyOtpCodeForPhone',
      { otpCode, phoneNumber, recaptchaToken },
      {
        success: true,
        user: {
          structure: {
            id: true
          }
        },
        errors: {
          structure: {
            code: true,
            description: true
          }
        }
      }
    )
  }

  static createOtpCode ({ email, phoneNumber, recaptchaToken = null } = {}) {
    if (email) {
      return this.createOtpCodeForEmail(email, recaptchaToken)
    } else if (phoneNumber) {
      return this.createOtpCodeForPhone(phoneNumber, recaptchaToken)
    } else {
      throw new Error('Either email or phoneNumber must be provided')
    }
  }

  static verifyOtpCode ({ otpCode, email, phoneNumber, recaptchaToken = null } = {}) {
    if (email) {
      return this.verifyOtpCodeForEmail(otpCode, email, recaptchaToken)
    } else if (phoneNumber) {
      return this.verifyOtpCodeForPhone(otpCode, phoneNumber, recaptchaToken)
    } else {
      throw new Error('Either email or phoneNumber must be provided')
    }
  }
}
